import styled from 'styled-components';

import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { StarkwareEscapeHatch } from '#src/components/wallet/StarkwareEscapeHatch/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import { CryptoBalance } from './CryptoBalance/index.tsx';
import { Deposit } from './Deposit/index.tsx';
import { FiatBalance } from './FiatBalance/index.tsx';

const Root = styled(Vertical).attrs({ gap: 0 })`
  border: 1px solid var(--c-nd-150);
  border-radius: var(--unit);
`;
const StyledHorizontal = styled(Horizontal).attrs({ gap: 0 })`
  border-bottom: 1px solid var(--c-nd-150);
  & > * {
    flex: 1;
    padding: var(--unit);
    text-align: center;
  }
  .sidebarCollapsed & {
    flex-direction: column;

    & > * {
      width: 100%;
      padding: var(--unit) var(--half-unit);
    }

    & > :first-child {
      border-bottom: 1px solid var(--c-nd-150);
      border-right: none;
    }
  }

  & > :first-child {
    border-right: 1px solid var(--c-nd-150);
  }
  &:hover {
    background-color: var(--c-nd-50);
  }

  transition:
    300ms background-color ease-in-out,
    300ms color ease-in-out,
    300ms border-color ease-in-out;
`;

type Props = { onClick?: () => void; sidebarCollapsed?: boolean };
export const MoneyBalances = ({ onClick, sidebarCollapsed }: Props) => {
  const {
    walletPreferences: { showCryptoWallet },
  } = useCurrentUserContext();

  return (
    <Root>
      <StyledHorizontal>
        <button onClick={onClick} type="button">
          <FiatBalance collapsed={sidebarCollapsed} />
        </button>
        {!!showCryptoWallet && (
          <button onClick={onClick} type="button">
            <CryptoBalance collapsed={sidebarCollapsed} />
          </button>
        )}
      </StyledHorizontal>
      {!sidebarCollapsed && <StarkwareEscapeHatch />}
      <Deposit onClick={onClick} sidebarCollapsed={sidebarCollapsed} />
    </Root>
  );
};
